export default __webpack_public_path__ + "static/media/standard-management.599417cf.svg";